import styled, { css } from 'styled-components';
import { TextInput } from '@prisjakt/ui-inputs';
import * as base from '@prisjakt/ui-base';
import * as UiButton from '@prisjakt/ui-button';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import { Variant } from './types';

export const Legal = styled.div`
  font-size: ${base.layout.fontSizes.small.desktop.rem};
  margin-top: ${base.layout.spacing.xSmall};
  text-decoration: underline;

  ${base.media.smallOnly`
    font-size: ${base.layout.fontSizes.small.mobile.rem};
    text-align: center;
  `}
`;

export const Feedback = styled.div`
  font-size: ${base.layout.fontSizes.small.desktop.rem};
`;

export const Title = styled.div`
  font-size: ${base.layout.fontSizes.base.desktop.rem};
  margin-bottom: ${base.layout.spacing.small};
`;

export const SubscribeTitle = styled.b`
  margin-left: ${base.layout.spacing.xSmall};
`;
export const SubscribeSubTitle = styled.div`
  margin-bottom: ${base.layout.spacing.xSmall};
  margin-top: ${base.layout.spacing.xSmall};
`;

export const SubscribedCheckIcon = styled(CheckCircleIcon).attrs(() => ({
  size: '16px',
}))`
  border-radius: 16px;
  background-color: white;
  fill: ${base.colors.green1};
  vertical-align: middle;
`;

export const Form = styled.form`
  margin-bottom: ${base.layout.spacing.xSmall};
`;

type InlineInputProps = { stacked?: boolean };
export const InlineInput = styled(TextInput)<InlineInputProps>`
  flex-grow: 1;

  ${p =>
    !p.stacked &&
    css`
      margin-right: 20px;
      margin-top: 2px;
    `}
`;

export const Flex = styled.div`
  display: flex;
  align-items: top;
  flex-direction: 'row';
  background-color: 'red';
`;

export const Text = styled.div`
  margin-bottom: ${base.layout.spacing.small};
`;

export const Button = styled(UiButton.default)`
  background-color: #000;
  margin-left: ${base.layout.spacing.xSmall};
  height: min-content;
`;

type NewsLetterProps = { variant: Variant } & { stacked: boolean };
export const NewsLetter = styled.div<NewsLetterProps>`
  margin: ${base.layout.spacing.xSmall};
  background: ${p => p.variant === 'secondary' && base.colors.lightBlue3};
  color: ${p => p.variant === 'secondary' && base.colors.white};
  ${Legal} a {
    color: ${p =>
      p.variant === 'primary' ? base.colors.darkGray4 : base.colors.lightGray1};
  }
  ${Feedback} {
    color: ${p =>
      p.variant === 'primary' ? base.colors.red1 : base.colors.lightGray1};
  }
  ${Flex} {
    flex-direction: ${p => (p.stacked ? 'column' : 'row')};
  }
  ${Button} {
    ${p =>
      p.stacked &&
      `margin-left: 0;
    margin-top: ${base.layout.spacing.xSmall};`}
  }
`;
